export default "__VITE_ASSET__78aa669e__"